import { useSelector } from 'react-redux'
import { userProfile } from '@views/profile/state/profileSlice'
import ClubComponent from './components/ClubComponent'
import { selectCredentials } from '@views/loginView/state/loginSlice'
import MemberFinder from './components/MemberFinder'
import { selectFoundMember } from './state/clubSlice'
import { Box, makeStyles, Tab, Tabs } from '@material-ui/core'
import { useState } from 'react'
import TeamList from './listView'
import './club.css'

const pages = ['Producción', 'Equipo']

const useStyles = makeStyles({
  root: {
    color: '#ffffff',
    fontWeight: 'bold',
    backgroundColor: '#ffa657 !important'
  },
  selected: {
    backgroundColor: '#fff !important',
    borderRadius: '1rem 1rem 0 0',
    marginTop: '0.5rem',
    color: '#ff7c0d'
  }
})

const ClubView = () => {
  const { name } = useSelector(userProfile)
  const { userId } = useSelector(selectCredentials)
  const foundMember = useSelector(selectFoundMember)
  const [page, setPage] = useState(pages[0])

  const classes = useStyles()

  return (
    <div style={{ marginTop: '84px' }}>
      <Tabs
        className="club-tabs"
        value={page}
        TabIndicatorProps={{
          style: {
            height: '0px'
          }
        }}
        onChange={(_e, newValue) => setPage(newValue)}
      >
        {pages.map(page => (
          <Tab
            classes={{
              root: classes.root,
              selected: classes.selected
            }}
            className="club-tab"
            label={page}
            value={page}
            key={page}
          />
        ))}
      </Tabs>
      {page === pages[0] ? (
        <>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
            alignItems="center"
            marginTop="1em"
            style={{
              backgroundColor: '#fff',
              padding: '0.5rem 1.5rem'
            }}
          >
            <Box>
              <h3 className="clubMember-title">El Club de: </h3>
              <div style={{ fontWeight: 'bold', color: '#ff6905' }}>{(foundMember?.name || name).toUpperCase()}</div>
            </Box>
            <MemberFinder />
          </Box>

          {foundMember?.name ? (
            <ClubComponent userId={foundMember._id || ''}></ClubComponent>
          ) : (
            <ClubComponent userId={userId}></ClubComponent>
          )}
        </>
      ) : (
        <TeamList />
      )}
    </div>
  )
}

export default ClubView
